import { HttpClient } from '@angular/common/http';
import { LsHelperService } from 'src/app/core/services/ls-helper.service';
import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/services/globals.service";
import * as i2 from "@angular/common/http";
import * as i3 from "../../../core/services/ls-helper.service";
export class TransactionProfileService extends BaseProvider {
    constructor(globals, http, ls) {
        super();
        this.globals = globals;
        this.http = http;
        this.ls = ls;
        this.showManagement = false;
        this.itemToEdit = {};
        this.baseUrl = "profile";
    }
    getByUserProcessId(id) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/transaction/' + id;
            var loginData = this.ls.get('loginData');
            this.http.get(this.url)
                .subscribe((data) => {
                this.itemToEdit = data.Data;
                resolve(this.itemToEdit);
            }, err => { reject(err); });
        });
    }
}
TransactionProfileService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TransactionProfileService_Factory() { return new TransactionProfileService(i0.ɵɵinject(i1.GlobalsService), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.LsHelperService)); }, token: TransactionProfileService, providedIn: "root" });
